import React from "react";
import { BiMailSend } from "react-icons/bi";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full sm:h-[100vh] h-[110vh] bg-[#0a192f] flex justify-center items-center p-4"
    >
      <form
        method="POST"
        action="https://getform.io/f/d79267af-9730-4cdf-8628-189d5c6d5d71"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-cyan-600 text-gray-300">
            Contact
          </p>{" "}
          {/*'inline' determines the border's width  */}
          <p className="text-gray-300 py-4">
            || Submit the form below or send me an email at{" - "}
            <a
              href="mailto:bk14drobs@gmail.com"
              className="text-blue-400 font-bold underline hover:text-blue-200"
            >
              bk14drobs@gmail.com
            </a>
          </p>
        </div>
        <input
          className="bg-[#303a53] text-gray-100 p-2 rounded-lg"
          type="text"
          placeholder="Your Name"
          name="name"
          required
        />
        <input
          className="my-4 p-2 bg-[#303a53] text-gray-100 rounded-lg"
          type="email"
          placeholder="Your Email"
          name="email"
          required
        />
        <input
          className="mb-4 p-2 bg-[#303a53] text-gray-100 rounded-lg"
          type="text"
          placeholder="Subject"
          name="subject"
        />
        <textarea
          className="bg-[#303a53] text-gray-100 p-2 rounded-lg"
          name="message"
          rows="10"
          placeholder="Your Message Here..."
          required
        ></textarea>
        <button className="text-white border-2 hover:bg-cyan-600 hover:border-cyan-500 duration-300 group px-4 py-3 my-8 mx-auto flex items-center rounded-lg">
          Submit
          <span className="group-hover:translate-x-2 duration-500">
            <BiMailSend className="ml-3 text-3xl" />
          </span>
        </button>
      </form>
    </div>
  );
};

export default Contact;
